import Vue from 'vue'
import Router from 'vue-router'
import Account from '@/components/pages/account'
import Address from '@/components/pages/address'
import Children from '@/components/pages/children'
import Payment from '@/components/pages/payment'
import Review from '@/components/pages/review'
import Success from '@/components/pages/success'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'start',
      component: Account
    },
    {
      path: '*',
      component: {
        template: '<div>404 page not found</div>'
      }
    },
    {
      path: '/account',
      name: 'account',
      component: Account
    },
    {
      path: '/children',
      name: 'children',
      component: Children
    },
    {
      path: '/address',
      name: 'addesss',
      component: Address
    },
    {
      path: '/payment',
      name: 'payment',
      component: Payment
    },
    {
      path: '/review',
      name: 'review',
      component: Review
    },
    {
      path: '/success',
      name: 'success',
      component: Success
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    // return desired position
    // return new Promise((resolve, reject) => {
    //   setTimeout(() => {
    //     resolve({ x: 0, y: 0 })
    //   }, 2000)
    // })
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js